import { render, staticRenderFns } from "./updatelicense.vue?vue&type=template&id=a644fec2&"
import script from "./updatelicense.vue?vue&type=script&lang=js&"
export * from "./updatelicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports